export default function TS_Explicit_Inference() {
  return (
    <div>
      <h1>TS Explicit & Inference</h1>
      <p>This is the TS Explicit & Inference page.</p>
    </div>
  );
}